import * as types from '../../../lib/actionTypes.es6';

export var getOrgClaimInitConfigsRequest = function(organizationGuid) {
  return { type: types.GET_ORG_CLAIM_INIT_CONFIGS_REQUEST, payload: organizationGuid };
};
export var getOrgClaimInitConfigsSuccess = function(payload) {
  return { type: types.GET_ORG_CLAIM_INIT_CONFIGS_SUCCESS, payload: payload };
};
export var getOrgClaimInitConfigsFailure = function(error) {
  return { type: types.GET_ORG_CLAIM_INIT_CONFIGS_FAILURE, payload: error };
};
export var createOrgClaimInitConfigRequest = function(payload) {
  return { type: types.CREATE_ORG_CLAIM_INIT_CONFIG_REQUEST, payload: payload };
};
export var createOrgClaimInitConfigSuccess = function(payload) {
  return { type: types.CREATE_ORG_CLAIM_INIT_CONFIG_SUCCESS, payload: payload };
};
export var createOrgClaimInitConfigFailure = function(error) {
  return { type: types.CREATE_ORG_CLAIM_INIT_CONFIG_FAILURE, payload: error };
};
export var resetCreateOrgClaimInitConfigSuccess = function() {
  return { type: types.RESET_CREATE_ORG_CLAIM_INIT_CONFIG_SUCCESS };
};
export var resetCreateOrgClaimInitConfigError = function() {
  return { type: types.RESET_CREATE_ORG_CLAIM_INIT_CONFIG_ERROR };
};
export var updateOrgClaimInitConfigRequest = function(payload) {
  return { type: types.UPDATE_ORG_CLAIM_INIT_CONFIG_REQUEST, payload: payload };
};
export var updateOrgClaimInitConfigSuccess = function(payload) {
  return { type: types.UPDATE_ORG_CLAIM_INIT_CONFIG_SUCCESS, payload: payload };
};
export var updateOrgClaimInitConfigFailure = function(error) {
  return { type: types.UPDATE_ORG_CLAIM_INIT_CONFIG_FAILURE, payload: error };
};
export var resetUpdateOrgClaimInitConfigSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_CLAIM_INIT_CONFIG_SUCCESS };
};
export var resetUpdateOrgClaimInitConfigError = function() {
  return { type: types.RESET_UPDATE_ORG_CLAIM_INIT_CONFIG_ERROR };
};
export var deleteOrgClaimInitConfigRequest = function(payload) {
  return { type: types.DELETE_ORG_CLAIM_INIT_CONFIG_REQUEST, payload: payload };
};
export var deleteOrgClaimInitConfigSuccess = function(payload) {
  return { type: types.DELETE_ORG_CLAIM_INIT_CONFIG_SUCCESS, payload: payload };
};
export var deleteOrgClaimInitConfigFailure = function(error) {
  return { type: types.DELETE_ORG_CLAIM_INIT_CONFIG_FAILURE, payload: error };
};
export var resetDeleteOrgClaimInitConfigSuccess = function() {
  return { type: types.RESET_DELETE_ORG_CLAIM_INIT_CONFIG_SUCCESS };
};
export var resetDeleteOrgClaimInitConfigError = function() {
  return { type: types.RESET_DELETE_ORG_CLAIM_INIT_CONFIG_ERROR };
};
